import { inject } from '@angular/core';
import { FeatureFlagsStore } from '@marineform/fe-data-access';

export function manageFeatureFlagsInitializer() {
  return inject(FeatureFlagsStore).load();
}
